import { NgModule } from "@angular/core";
import { Routes, RouterModule, PreloadAllModules } from "@angular/router";

import { PcMilerResolver } from "./pcMiler/shared/pcMiler.resolver";

import { authenticationService } from "./login/auth.service";
import { HomeComponent } from "./home/home.component";
import { LoginComponent } from "./login/login.component";
import { ResetComponent } from "./login/reset.component";
import { NotFoundComponent } from "./not-found/not-found.component";
import { SchedulingTeamsComponent } from "./scheduling-teams/scheduling-teams.component";

// Still eagerly loaded in AppModule
import { PcMilerComponent } from "./pcMiler/pcMiler.component";
import { Permissions } from "@models/permissions.enum";

export const routes: Routes = [
  { path: "", pathMatch: "full", redirectTo: "home" },
  { path: "login", component: LoginComponent },
  { path: "reset", component: ResetComponent },
  {
    path: "home",
    component: HomeComponent,
    canActivate: [authenticationService],
    data: { permission: Permissions.DashboardRead },
  },
  {
    path: "scheduling-teams",
    component: SchedulingTeamsComponent,
    canActivate: [authenticationService],
    data: { permission: Permissions.BoardsRead },
  },

  { path: "", loadChildren: () => import("./lessor/lessor.module").then((m) => m.LessorModule) },
  { path: "", loadChildren: () => import("./agilx/agilx.module").then((m) => m.AgilxModule) },
  {
    path: "",
    loadChildren: () => import("./chargeType/charge-type.module").then((m) => m.ChargeTypeModule),
  },
  {
    path: "",
    loadChildren: () => import("./equipment/equipment.module").then((m) => m.EquipmentModule),
  },
  { path: "", loadChildren: () => import("./product/product.module").then((m) => m.ProductModule) },
  {
    path: "",
    loadChildren: () =>
      import("./peoplenet-test/peoplenet-test.module").then((m) => m.PeoplenetTestModule),
  },
  { path: "", loadChildren: () => import("./efs/efs.module").then((m) => m.EfsModule) },
  {
    path: "",
    loadChildren: () => import("./utilities/utilities.module").then((m) => m.UtilitiesModule),
  },
  { path: "", loadChildren: () => import("./fuel/fuel.module").then((m) => m.FuelModule) },
  { path: "", loadChildren: () => import("./trailer/trailer.module").then((m) => m.TrailerModule) },
  { path: "", loadChildren: () => import("./tractor/tractor.module").then((m) => m.TractorModule) },
  {
    path: "",
    loadChildren: () => import("./locations/locations.module").then((m) => m.LocationsModule),
  },
  {
    path: "",
    loadChildren: () => import("./settlements/settlements.module").then((m) => m.SettlementsModule),
  },
  {
    path: "",
    loadChildren: () => import("./rates/rates.module").then((m) => m.RatesModule),
  },
  {
    path: "",
    loadChildren: () => import("./client/client.module").then((m) => m.ClientModule),
  },
  {
    path: "",
    loadChildren: () => import("./dispatch-schedule/dispatch.module").then((m) => m.DispatchModule),
  },
  {
    path: "",
    loadChildren: () => import("./driver/driver.module").then((m) => m.DriverModule),
  },

  {
    path: "new",
    loadChildren: () => import("./newtrip/trip.module").then((m) => m.NewtripModule),
    data: { permission: Permissions.BillingQueueRead },
  },
  {
    path: "reports",
    loadChildren: () => import("./reports/reports.module").then((m) => m.ReportsModule),
  },
  {
    path: "customer-exports",
    loadChildren: () =>
      import("./customer-exports/customer-exports.module").then((m) => m.CustomerExportsModule),
    data: { permission: Permissions.CustomerReportsRead },
  },
  {
    path: "equipment-report",
    loadChildren: () =>
      import("./equipment-report/equipment-report.module").then((m) => m.EquipmentReportModule),
    data: { permission: Permissions.TrailersRead },
  },
  {
    path: "testing",
    loadChildren: () =>
      import("./trip-new/shared/testing/trip-testing.module").then((m) => m.ReportsModule),
    canActivate: [authenticationService],
    data: { permission: Permissions.Admin },
  },

  {
    path: "PcMilerSettings",
    component: PcMilerComponent,
    resolve: { PcMilerSettings: PcMilerResolver },
    canActivate: [authenticationService],
    data: { permission: Permissions.PCMilerChange },
  },

  { path: "dispatch-schedule", redirectTo: "dispatch", pathMatch: "full" },
  { path: "dispatch-trips", redirectTo: "dispatch", pathMatch: "full" },

  { path: "**", component: NotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: "enabled",
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
